import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { AuthenticationService } from './core/services/authentication.service';
import { ConfigurationService } from './core/services/configuration.service';
import { VersionBadgeComponent } from './shared/components/version-badge/version-badge.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        ToastModule,
        ConfirmDialogModule,
        RouterOutlet,
        VersionBadgeComponent
    ]
})
export class AppComponent {

    title = 'angular';

    constructor(
        private readonly translate: TranslateService,
        public readonly configurationService: ConfigurationService,
        private readonly authenticationService: AuthenticationService,
        private readonly primeng: PrimeNG
    ) {
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translate.setDefaultLang('es');

        // add app languages
        this.translate.addLangs(['en', 'es', 'ca']);

        // the lang to use, if the lang isn't available, it will use the current loader to get them
        this.translate.use('es');

        // PrimeNG Configuration
        this.translate.get('primeng').subscribe(res => this.primeng.setTranslation(res));

        this.authenticationService.currentUser.subscribe(async user => {
            if (user) {
                // this.configurationService.getConfiguration();
                await this.configurationService.setInitialConfgiguration();
                this.configurationService.setStyle();
            }
        });
    }
}
